import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Maybe } from '../../../utils/apollo/graphqlSchema';
import { IWorkspaceItem, IWorkspacesSlice } from './types';

const initialState: IWorkspacesSlice = {
  workspaceList: [],
  lastVisitedWorkspacePathname: null,
};

export default createSlice({
  name: 'workspaces',
  initialState,
  reducers: {
    populateWorkspaces: (draft, action: PayloadAction<IWorkspaceItem[]>) => {
      draft.workspaceList = action.payload;
    },
    clearWorkspaces: (draft) => {
      return {
        ...initialState,
        lastVisitedWorkspacePathname: draft.lastVisitedWorkspacePathname,
      };
    },

    setWorkspaceLastVisitedPathname: (
      draft,
      action: PayloadAction<{
        lastVisitedPathname: Maybe<string>;
      }>,
    ) => {
      draft.lastVisitedWorkspacePathname = action.payload.lastVisitedPathname;
    },

    updateWorkspaces: (draft, action: PayloadAction<IWorkspaceItem>) => {
      const payloadWorkspace = action.payload;

      const stateWorkspaceIndex = draft.workspaceList.findIndex(
        (entity) => entity.id === payloadWorkspace.id,
      );

      if (stateWorkspaceIndex === -1) {
        return;
      }

      draft.workspaceList = draft.workspaceList.map((workspace, index) => {
        if (stateWorkspaceIndex === index) {
          return payloadWorkspace;
        }

        return workspace;
      });
    },
  },
});
